"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const outlineContext = (0, react_1.createContext)(null);
exports.default = outlineContext;
